module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.contactDialog),
      callback: function($$v) {
        _vm.contactDialog = $$v
      },
      expression: "contactDialog"
    }
  }, [_c('v-card', [(_vm.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Contact Info")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": "",
      "disabled": _vm.customerID === null || !_vm.newContactValid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveContact($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "newContact",
    model: {
      value: (_vm.newContactValid),
      callback: function($$v) {
        _vm.newContactValid = $$v
      },
      expression: "newContactValid"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Contact Name",
      "rules": [function (v) { return !!v || 'Name is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.contactEditedItem.Name),
      callback: function($$v) {
        _vm.$set(_vm.contactEditedItem, "Name", $$v)
      },
      expression: "contactEditedItem.Name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email Address",
      "rules": [function (v) { return !!v || 'E-mail is required'; }, function (v) { return /.+@.+/.test(v) || 'E-mail must be valid'; }],
      "required": "",
      "append-outer-icon": 'mdi-send'
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.doLink('EmailAddress', 'mailto')
      }
    },
    model: {
      value: (_vm.contactEditedItem.EmailAddress),
      callback: function($$v) {
        _vm.$set(_vm.contactEditedItem, "EmailAddress", $$v)
      },
      expression: "contactEditedItem.EmailAddress"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Phone",
      "rules": [function (v) { return !!v || 'phone is required'; }],
      "append-outer-icon": 'mdi-phone',
      "required": ""
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.doLink('Phone', 'tel')
      }
    },
    model: {
      value: (_vm.contactEditedItem.Phone),
      callback: function($$v) {
        _vm.$set(_vm.contactEditedItem, "Phone", $$v)
      },
      expression: "contactEditedItem.Phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Mobile",
      "append-outer-icon": 'mdi-phone',
      "required": ""
    },
    on: {
      "click:append-outer": function($event) {
        return _vm.doLink('Mobile', 'tel')
      }
    },
    model: {
      value: (_vm.contactEditedItem.Mobile),
      callback: function($$v) {
        _vm.$set(_vm.contactEditedItem, "Mobile", $$v)
      },
      expression: "contactEditedItem.Mobile"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "browser-autocomplete": "disabled",
      "label": "Company",
      "items": _vm.customerArray,
      "item-text": "name",
      "item-value": "key",
      "rules": [function (v) { return !!v || 'Company Name is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.customerID),
      callback: function($$v) {
        _vm.customerID = $$v
      },
      expression: "customerID"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Sites",
      "items": _vm.sites,
      "chips": "",
      "item-text": "Name",
      "item-value": "id",
      "rules": [function (v) { return !!v || 'Site Name is required'; }],
      "multiple": "",
      "required": ""
    },
    model: {
      value: (_vm.contactEditedItem.Site),
      callback: function($$v) {
        _vm.$set(_vm.contactEditedItem, "Site", $$v)
      },
      expression: "contactEditedItem.Site"
    }
  }), _vm._v(" "), _c('v-card-title', [_vm._v("Contact Type")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Accounts",
      "color": "primary"
    },
    model: {
      value: (_vm.contactEditedItem.Accounts),
      callback: function($$v) {
        _vm.$set(_vm.contactEditedItem, "Accounts", $$v)
      },
      expression: "contactEditedItem.Accounts"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Fleet",
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.contactEditedItem.Fleet),
      callback: function($$v) {
        _vm.$set(_vm.contactEditedItem, "Fleet", $$v)
      },
      expression: "contactEditedItem.Fleet"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Comms",
      "color": "primary"
    },
    model: {
      value: (_vm.contactEditedItem.Comms),
      callback: function($$v) {
        _vm.$set(_vm.contactEditedItem, "Comms", $$v)
      },
      expression: "contactEditedItem.Comms"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('a', {
    ref: "link",
    attrs: {
      "href": 'mailto:' + _vm.contactEditedItem.EmailAddress
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b36ad876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ContactEditDialog.vue
// module id = 762
// module chunks = 1